<template>
  <div class="package-advantages">
    <div v-if="title" class="package-advantages__label">{{ title }}</div>
    <ul class="package-advantages__list">
      <li
        v-for="advantage in advantages"
        :key="advantage"
        :class="{
          'package-advantages__item': true,
          'package-advantages__item--free': isFreePackage,
          'package-advantages__item--paid': !isFreePackage,
        }"
      >
        <span class="package-advantages__icon" aria-hidden="true">
          {{ isFreePackage ? '✕' : '✓' }}
        </span>
        <span class="package-advantages__text">
          {{ advantage }}
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
const SHARED_ADVANTAGES = [
  'Werbefreiheit',
  'höherer Listenplatz als "free"',
  'größere Bildergalerie (bis zu 15)',
  'jederzeit kündbar',
  'Link zur eigenen Homepage',
  'Link zum eigenen Buchungssystem',
  'priorisierter Support',
]

const TYPE_SPECIFIC_ADVANTAGES = {
  unterkunft: [
    'Anfragen über unser System (mit Spamfilter & optimiertem Formular)',
  ],
  termine: [],
  angebote: [],
}

export default {
  name: "PackageAdvantages",
  props: {
    baseType: {
      type: String,
      default: '',
    },
    sourceKind: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: 'Vorteile',
    },
  },
  computed: {
    isFreePackage() {
      return this.sourceKind === 'free'
    },
    advantages() {
      return [
        ...SHARED_ADVANTAGES,
        ...(TYPE_SPECIFIC_ADVANTAGES[this.baseType] || []),
      ]
    },
  },
}
</script>

<style scoped lang="scss">
.package-advantages__label {
  margin-bottom: 0.35rem;
  color: #5d7183;
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.package-advantages__list {
  margin: 0;
  padding-left: 0;
  color: #1e3346;
  font-size: 0.9rem;
  list-style: none;
}

.package-advantages__item {
  display: flex;
  align-items: flex-start;
  gap: 0.45rem;
}

.package-advantages__item + .package-advantages__item {
  margin-top: 0.2rem;
}

.package-advantages__icon {
  flex-shrink: 0;
  font-size: 0.95rem;
  font-weight: 700;
  line-height: 1.35;
}

.package-advantages__item--paid .package-advantages__icon {
  color: #198754;
}

.package-advantages__item--free .package-advantages__icon {
  color: #dc3545;
}

.package-advantages__item--free .package-advantages__text {
  color: #7b8691;
  text-decoration: line-through;
  text-decoration-thickness: 1.5px;
}
</style>
